import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 *  FUTÁR MÓD az ügyfélkártyán (backend: naplo-futar.js).
 *
 *  A futárnak (egyéni vállalkozó) a Wolt és a foodora a futár nevében állít ki számlát (önszámlázás), és az
 *  adatot a futár adószámán beküldi a NAV-nak. Bekapcsolt futár módban a NAV-szinkron legfeljebb 15 percenként
 *  fut, a platformnak kiállított kimenő számlák pedig magától a naplóba kerülnek. A panel a NAV-kapcsolat
 *  állapotát, a platformonkénti összesítőt és a számlákat mutatja; a „Lekérés most” azonnal indítja a szinkront.
 */
@Component({
  selector: 'app-futar-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './futar-panel.component.html',
  styleUrls: ['./futar-panel.component.scss'],
})
export class FutarPanelComponent implements OnChanges {
  @Input() ugyfelId = '';
  adat: any = null;
  hiba = '';
  uzenet = '';
  fut = false;

  constructor(private http: HttpClient) {}

  async ngOnChanges() { await this.betolt(); }
  async betolt() {
    if (!this.ugyfelId) { this.adat = null; return; }
    this.hiba = '';
    try { this.adat = await firstValueFrom(this.http.get(`/api/naplo/futar/${this.ugyfelId}`)); }
    catch (e: any) { this.adat = null; this.hiba = e?.error?.error || 'A futárszámlák nem tölthetők be.'; }
  }
  async lekeres() {
    this.fut = true; this.hiba = ''; this.uzenet = '';
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/naplo/futar/${this.ugyfelId}/lekeres`, {}));
      const f = r.futar || {};
      this.uzenet = f.kettos
        ? `NAV-lekérés kész (${r.osszes} számla). Kettős könyvvitelnél a futárszámlákat nem könyveljük magától – ${f.varo || 0} vár.`
        : `NAV-lekérés kész: ${r.uj} új számla, ${f.konyvelve || 0} futárszámla lekönyvelve${f.kepek?.dokumentumbol || f.kepek?.szamlazobol ? `, ${(f.kepek.dokumentumbol || 0) + (f.kepek.szamlazobol || 0)} számlakép hozzákötve` : ''}.${f.hibak?.length ? ` Hiba: ${f.hibak.join('; ')}` : ''}`;
      await this.betolt();
    } catch (e: any) { this.hiba = e?.error?.error || 'A NAV-lekérés nem sikerült.'; }
    this.fut = false;
  }
  szam(v: any) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 0 }); }
  platformNev(k: string) { return this.adat?.platformok?.find((p: any) => p.kod === k)?.nev || k; }
}
